const languageMaster =
    [
        {
            "languageid": 1,
            "language": "English",
            "languagecode": "en",
            "active": 1,
        },
        {
            "languageid": 2,
            "language": "Hindi",
            "languagecode": "hi",
            "active": 1,
        },
        {
            "languageid": 3,
            "language": "Arabic",
            "languagecode": "ar",
            "active": 1,

        },
        {
            "languageid": 4,
            "language": "Gujarati",
            "languagecode": "gu",
            "active": 1,
        },
        {
            "languageid": 5,
            "language": "Tamil",
            "languagecode": "ta",
            "active": 1,
        },
        {
            "languageid": 6,
            "language": "Bengali",
            "languagecode": "bn",
            "active": 1,
        },
        {
            "languageid": 7,
            "language": "Urdu",
            "languagecode": "ur",
            "active": 0,
        },
        {
            "languageid": 8,
            "language": "Spanish",
            "languagecode": "es",
            "active": 1,
        },
        {
            "languageid": 9,
            "language": "Marathi",
            "languagecode": "mr",
            "active": 1,
        },
        {
            "languageid": 10,
            "language": "Telugu",
            "languagecode": "te",
            "active": 1,
        },
        {
            "languageid": 11,
            "language": "French",
            "languagecode": "fr",
            "active": 1,
        },
        {
            "languageid": 12,
            "language": "Russian",
            "languagecode": "ru",
            "active": 0,
        },
        {
            "languageid": 13,
            "language": "Japanese",
            "languagecode": "ja",
            "active": 0,
        },
        {
            "languageid": 14,
            "language": "German",
            "languagecode": "de",
            "active": 1,
        },
        {
            "languageid": 15,
            "language": "Afrikaans ",
            "languagecode": "af",
            "active": 0,
        },
        {
            "languageid": 16,
            "language": "Albanian ",
            "languagecode": "sq",
            "active": 0,
        },
        {
            "languageid": 17,
            "language": "Amharic ",
            "languagecode": "am",
            "active": 0,
        },
        {
            "languageid": 18,
            "language": "Armenian ",
            "languagecode": "hy",
            "active": 0,
        },
        {
            "languageid": 19,
            "language": "Assamese ",
            "languagecode": "as",
            "active": 1,
        },
        {
            "languageid": 20,
            "language": "Aymara ",
            "languagecode": "ay",
            "active": 0,
        },
        {
            "languageid": 21,
            "language": "Azerbaijani ",
            "languagecode": "az",
            "active": 0,
        },
        {
            "languageid": 22,
            "language": "Bambara ",
            "languagecode": "bm",
            "active": 0,
        },
        {
            "languageid": 23,
            "language": "Basque ",
            "languagecode": "eu",
            "active": 0,
        },
        {
            "languageid": 24,
            "language": "Belarusian ",
            "languagecode": "be",
            "active": 0,
        },
        {
            "languageid": 25,
            "language": "Bhojpuri ",
            "languagecode": "bho",
            "active": 0,
        },
        {
            "languageid": 26,
            "language": "Bosnian ",
            "languagecode": "bs",
            "active": 0,
        },
        {
            "languageid": 27,
            "language": "Bulgarian ",
            "languagecode": "bg",
            "active": 0,
        },
        {
            "languageid": 28,
            "language": "Catalan ",
            "languagecode": "ca",
            "active": 0,
        },
        {
            "languageid": 29,
            "language": "Cebuano ",
            "languagecode": "ceb",
            "active": 0,
        },
        {
            "languageid": 30,
            "language": "Corsican ",
            "languagecode": "co",
            "active": 0,
        },
        {
            "languageid": 31,
            "language": "Croatian ",
            "languagecode": "hr",
            "active": 0,
        },
        {
            "languageid": 32,
            "language": "Czech ",
            "languagecode": "cs",
            "active": 0,
        },
        {
            "languageid": 33,
            "language": "Danish ",
            "languagecode": "da",
            "active": 0,
        },
        {
            "languageid": 34,
            "language": "Dhivehi ",
            "languagecode": "dv",
            "active": 0,
        },
        {
            "languageid": 35,
            "language": "Dogri ",
            "languagecode": "doi",
            "active": 0,
        },
        {
            "languageid": 36,
            "language": "Dutch ",
            "languagecode": "nl",
            "active": 0,
        },
        {
            "languageid": 37,
            "language": "Esperanto ",
            "languagecode": "eo",
            "active": 0,
        },
        {
            "languageid": 38,
            "language": "Estonian ",
            "languagecode": "et",
            "active": 0,
        },
        {
            "languageid": 39,
            "language": "Ewe ",
            "languagecode": "ee",
            "active": 0,
        },
        {
            "languageid": 40,
            "language": "Filipino Tagalog",
            "languagecode": "fil",
            "active": 0,
        },
        {
            "languageid": 41,
            "language": "Finnish ",
            "languagecode": "fi",
            "active": 0,
        },
        {
            "languageid": 42,
            "language": "Frisian ",
            "languagecode": "fy",
            "active": 0,
        },
        {
            "languageid": 43,
            "language": "Galician ",
            "languagecode": "gl",
            "active": 0,
        },
        {
            "languageid": 44,
            "language": "Georgian ",
            "languagecode": "ka",
            "active": 0,
        },
        {
            "languageid": 45,
            "language": "Greek ",
            "languagecode": "el",
            "active": 0,
        },
        {
            "languageid": 46,
            "language": "Guarani ",
            "languagecode": "gn",
            "active": 0,
        },
        {
            "languageid": 47,
            "language": "Haitian Creole ",
            "languagecode": "ht",
            "active": 0,
        },
        {
            "languageid": 48,
            "language": "Hausa ",
            "languagecode": "ha",
            "active": 0,
        },
        {
            "languageid": 49,
            "language": "Hawaiian ",
            "languagecode": "haw",
            "active": 0,
        },
        {
            "languageid": 50,
            "language": "Hebrew ",
            "languagecode": "he or iw",
            "active": 0,
        },
        {
            "languageid": 51,
            "language": "Hmong ",
            "languagecode": "hmn",
            "active": 0,
        },
        {
            "languageid": 52,
            "language": "Hungarian ",
            "languagecode": "hu",
            "active": 0,
        },
        {
            "languageid": 53,
            "language": "Icelandic ",
            "languagecode": "is",
            "active": 0,
        },
        {
            "languageid": 54,
            "language": "Igbo ",
            "languagecode": "ig",
            "active": 0,
        },
        {
            "languageid": 55,
            "language": "Ilocano ",
            "languagecode": "ilo",
            "active": 0,
        },
        {
            "languageid": 56,
            "language": "Indonesian ",
            "languagecode": "id",
            "active": 0,
        },
        {
            "languageid": 57,
            "language": "Irish ",
            "languagecode": "ga",
            "active": 0,
        },
        {
            "languageid": 58,
            "language": "Italian ",
            "languagecode": "it",
            "active": 0,
        },
        {
            "languageid": 59,
            "language": "Javanese ",
            "languagecode": "jv or jw",
            "active": 0,
        },
        {
            "languageid": 60,
            "language": "Kannada ",
            "languagecode": "kn",
            "active": 1,
        },
        {
            "languageid": 61,
            "language": "Kazakh ",
            "languagecode": "kk",
            "active": 0,
        },
        {
            "languageid": 62,
            "language": "Khmer ",
            "languagecode": "km",
            "active": 0,
        },
        {
            "languageid": 63,
            "language": "Kinyarwanda ",
            "languagecode": "rw",
            "active": 0,
        },
        {
            "languageid": 64,
            "language": "Konkani ",
            "languagecode": "gom",
            "active": 0,
        },
        {
            "languageid": 65,
            "language": "Korean ",
            "languagecode": "ko",
            "active": 0,
        },
        {
            "languageid": 66,
            "language": "Krio ",
            "languagecode": "kri",
            "active": 0,
        },
        {
            "languageid": 67,
            "language": "Kurdish ",
            "languagecode": "ku",
            "active": 0,
        },
        {
            "languageid": 68,
            "language": "Kurdish Sorani",
            "languagecode": "ckb",
            "active": 0,
        },
        {
            "languageid": 69,
            "language": "Kyrgyz ",
            "languagecode": "ky",
            "active": 0,
        },
        {
            "languageid": 70,
            "language": "Lao ",
            "languagecode": "lo",
            "active": 0,
        },
        {
            "languageid": 71,
            "language": "Latin ",
            "languagecode": "la",
            "active": 0,
        },
        {
            "languageid": 72,
            "language": "Latvian ",
            "languagecode": "lv",
            "active": 0,
        },
        {
            "languageid": 73,
            "language": "Lingala ",
            "languagecode": "ln",
            "active": 0,
        },
        {
            "languageid": 74,
            "language": "Lithuanian ",
            "languagecode": "lt",
            "active": 0,
        },
        {
            "languageid": 75,
            "language": "Luganda ",
            "languagecode": "lg",
            "active": 0,
        },
        {
            "languageid": 76,
            "language": "Luxembourgish ",
            "languagecode": "lb",
            "active": 0,
        },
        {
            "languageid": 77,
            "language": "Macedonian ",
            "languagecode": "mk",
            "active": 0,
        },
        {
            "languageid": 78,
            "language": "Maithili ",
            "languagecode": "mai",
            "active": 0,
        },
        {
            "languageid": 79,
            "language": "Malagasy ",
            "languagecode": "mg",
            "active": 0,
        },
        {
            "languageid": 80,
            "language": "Malay ",
            "languagecode": "ms",
            "active": 0,
        },
        {
            "languageid": 81,
            "language": "Malayalam ",
            "languagecode": "ml",
            "active": 1,
        },
        {
            "languageid": 82,
            "language": "Maltese ",
            "languagecode": "mt",
            "active": 0,
        },
        {
            "languageid": 83,
            "language": "Maori ",
            "languagecode": "mi",
            "active": 0,
        },
        {
            "languageid": 84,
            "language": "Meiteilon Manipuri",
            "languagecode": "mni-Mtei",
            "active": 0,
        },
        {
            "languageid": 85,
            "language": "Mizo ",
            "languagecode": "lus",
            "active": 0,
        },
        {
            "languageid": 86,
            "language": "Mongolian ",
            "languagecode": "mn",
            "active": 0,
        },
        {
            "languageid": 87,
            "language": "Myanmar Burmese",
            "languagecode": "my",
            "active": 0,
        },
        {
            "languageid": 88,
            "language": "Nepali ",
            "languagecode": "ne",
            "active": 0,
        },
        {
            "languageid": 89,
            "language": "Norwegian ",
            "languagecode": "no",
            "active": 0,
        },
        {
            "languageid": 90,
            "language": "Nyanja Chichewa",
            "languagecode": "ny",
            "active": 0,
        },
        {
            "languageid": 91,
            "language": "Odia Oriya",
            "languagecode": "or",
            "active": 1,
        },
        {
            "languageid": 92,
            "language": "Oromo ",
            "languagecode": "om",
            "active": 0,
        },
        {
            "languageid": 93,
            "language": "Pashto ",
            "languagecode": "ps",
            "active": 0,
        },
        {
            "languageid": 94,
            "language": "Persian ",
            "languagecode": "fa",
            "active": 0,
        },
        {
            "languageid": 95,
            "language": "Polish ",
            "languagecode": "pl",
            "active": 0,
        },
        {
            "languageid": 96,
            "language": "Portuguese Portugal, Brazil",
            "languagecode": "pt",
            "active": 0,
        },
        {
            "languageid": 97,
            "language": "Punjabi ",
            "languagecode": "pa",
            "active":1,
        },
        {
            "languageid": 98,
            "language": "Quechua ",
            "languagecode": "qu",
            "active": 0,
        },
        {
            "languageid": 99,
            "language": "Romanian ",
            "languagecode": "ro",
            "active": 0,
        },
        {
            "languageid": 100,
            "language": "Samoan ",
            "languagecode": "sm",
            "active": 0,
        },
        {
            "languageid": 101,
            "language": "Sanskrit ",
            "languagecode": "sa",
            "active": 0,
        },
        {
            "languageid": 102,
            "language": "Scots Gaelic ",
            "languagecode": "gd",
            "active": 0,
        },
        {
            "languageid": 103,
            "language": "Sepedi ",
            "languagecode": "nso",
            "active": 0,
        },
        {
            "languageid": 104,
            "language": "Serbian ",
            "languagecode": "sr",
            "active": 0,
        },
        {
            "languageid": 105,
            "language": "Sesotho ",
            "languagecode": "st",
            "active": 0,
        },
        {
            "languageid": 106,
            "language": "Shona ",
            "languagecode": "sn",
            "active": 0,
        },
        {
            "languageid": 107,
            "language": "Sindhi ",
            "languagecode": "sd",
            "active": 0,
        },
        {
            "languageid": 108,
            "language": "Sinhala Sinhalese",
            "languagecode": "si",
            "active": 0,
        },
        {
            "languageid": 109,
            "language": "Slovak ",
            "languagecode": "sk",
            "active": 0,
        },
        {
            "languageid": 110,
            "language": "Slovenian ",
            "languagecode": "sl",
            "active": 0,
        },
        {
            "languageid": 111,
            "language": "Somali ",
            "languagecode": "so",
            "active": 0,
        },
        {
            "languageid": 112,
            "language": "Sundanese ",
            "languagecode": "su",
            "active": 0,
        },
        {
            "languageid": 113,
            "language": "Swahili ",
            "languagecode": "sw",
            "active": 0,
        },
        {
            "languageid": 114,
            "language": "Swedish ",
            "languagecode": "sv",
            "active": 0,
        },
        {
            "languageid": 115,
            "language": "Tagalog Filipino",
            "languagecode": "tl",
            "active": 0,
        },
        {
            "languageid": 116,
            "language": "Tajik ",
            "languagecode": "tg",
            "active": 0,
        },
        {
            "languageid": 117,
            "language": "Tatar ",
            "languagecode": "tt",
            "active": 0,
        },
        {
            "languageid": 118,
            "language": "Thai ",
            "languagecode": "th",
            "active": 0,
        },
        {
            "languageid": 119,
            "language": "Tigrinya ",
            "languagecode": "ti",
            "active": 0,
        },
        {
            "languageid": 120,
            "language": "Tsonga ",
            "languagecode": "ts",
            "active": 0,
        },
        {
            "languageid": 121,
            "language": "Turkish ",
            "languagecode": "tr",
            "active": 0,
        },
        {
            "languageid": 122,
            "language": "Turkmen ",
            "languagecode": "tk",
            "active": 0,
        },
        {
            "languageid": 123,
            "language": "Twi Akan",
            "languagecode": "ak",
            "active": 0,
        },
        {
            "languageid": 124,
            "language": "Ukrainian ",
            "languagecode": "uk",
            "active": 0,
        },
        {
            "languageid": 125,
            "language": "Uyghur ",
            "languagecode": "ug",
            "active": 0,
        },
        {
            "languageid": 126,
            "language": "Uzbek ",
            "languagecode": "uz",
            "active": 0,
        },
        {
            "languageid": 127,
            "language": "Vietnamese ",
            "languagecode": "vi",
            "active": 0,
        },
        {
            "languageid": 128,
            "language": "Welsh ",
            "languagecode": "cy",
            "active": 0,
        },
        {
            "languageid": 129,
            "language": "Xhosa ",
            "languagecode": "xh",
            "active": 0,
        },
        {
            "languageid": 130,
            "language": "Yiddish ",
            "languagecode": "yi",
            "active": 0,
        },
        {
            "languageid": 131,
            "language": "Yoruba ",
            "languagecode": "yo",
            "active": 0,
        },
        {
            "languageid": 132,
            "language": "Zulu ",
            "languagecode": "zu",
            "active": 0,
        }
    ]

const getLanguageDetails = (key, value) => {
    switch (key) {
        case 'id':
            const languageById = languageMaster.find(item => item.languageid === value);
            return languageById ? languageById.language : null;

        case 'code':
            const languageByCode = languageMaster.find(item => item.languagecode === value);
            return languageByCode ? languageByCode.language : null;

        case 'name':
            return languageMaster.find(item => item.language === value);

        case 'langarr':
            return languageMaster.filter(item => item.active === 1);
        default:
            return null;
    }
};

 
export default getLanguageDetails;

